var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('circle',{pre:true,attrs:{"cx":"15","cy":"9","r":"6.5","opacity":".5"}}),_c('circle',{pre:true,attrs:{"cx":"9.5","cy":"14.5","r":"6.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }